import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { BACKEND_URL } from '../Constants';

const StudentTranscriptList = () => {
  const [studentSummaries, setStudentSummaries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchScores() {
      try {
        const enrollments = await axios.get(`${BACKEND_URL}/api/enrollments/all-quiz-scores`);
        const chatbot = await axios.get(`${BACKEND_URL}/api/quiz-progress/all`);
        const allScores = [...enrollments.data, ...chatbot.data];

        const grouped = {};

        allScores.forEach(score => {
          const email = score.studentEmail;
          if (!email) return;

          if (!grouped[email]) {
            grouped[email] = {
              studentName: score.studentName || 'Unnamed',
              studentEmail: email,
              percentages: []
            };
          }

          const percentage = score.maxScore > 0 ? (score.score / score.maxScore) * 100 : 0;
          grouped[email].percentages.push(percentage);
        });

        const summaries = Object.values(grouped).map(student => {
  const avg = student.percentages.length
    ? (student.percentages.reduce((sum, p) => sum + p, 0) / student.percentages.length).toFixed(2)
    : 'N/A';

  return {
    name: student.studentName,
    email: student.studentEmail,
    average: avg,
    totalQuizzes: student.percentages.length
  };
});

        setStudentSummaries(summaries);
      } catch (err) {
        console.error('Error fetching scores:', err);
      } finally {
        setLoading(false);
      }
    }

    fetchScores();
  }, []);

  if (loading) return <p className="text-muted fs-5">Loading student transcripts...</p>;

  return (
    <div className="container py-4">
      <h2 className="mb-4">Student Transcript Summary</h2>
      <table className="table table-hover">
        <thead className="bg-light">
          <tr>
            <th>Student Name</th>
            <th>Email</th>
            <th>Average Score</th>
    <th>Total Quizzes</th>
            <th>Transcript</th>
          </tr>
        </thead>
        <tbody>
          {studentSummaries.map((student, index) => (
            <tr key={index}>
              <td>{student.name}</td>
              <td>{student.email}</td>
              <td>{student.average}%</td>
      <td>{student.totalQuizzes}</td>
              <td>
                <Link to={`/dashboard/transcripts/${encodeURIComponent(student.email)}`} className="btn btn-sm btn-primary">
  View Transcript
</Link>

              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StudentTranscriptList;
